import { colors } from '../../colors';
var richText = {
  backgroundColor: colors.white,
  h1Color: colors.ash,
  h2Color: colors.ash,
  paraColor: colors.ash,
  anchorColor: colors.tomatoRed
};
export default richText;